declare var ExecutionTimeEnvironment: any; // SWH:  added this line on 10-16-2020.

export const environment = {
    debug: false,
    production: false,

    // 03-24-2020 change:  changed the capitalization of the following member to fix compilation issues.
    //loginSiteurl: "", //replace with your URL, e.g. "https://cs1806w1.sandbox.max.gov/",
    loginSiteUrl: "", //replace with your URL, e.g. "https://cs1806w1.sandbox.max.gov/",
    apiUrl: "", // 03-23-2020:  also added this member to fix some compilation issues.
    // End 03-24-2020 change.

    loginPage: "login",
    logoutPage: "logout",
    userGrantedAllClaims: false, // THIS IS TEMPORARY!
    suppressUnsavedChangesWarning: false,
    matomoConfig: {
        url: 'https://webmetrics.test.max.gov/',
        id: 38
    },
    sitename: 'OMB Collect', //VNEXT-1066: KLW - Variable to set site name
    //bannerColor: ExecutionTimeEnvironment.BANNER_COLOR //VNEXT-1181: KLW - For Banner Color based on environment implementation
};
